import React from 'react';
import { motion } from 'framer-motion';

const Banner = () => {
  return (
    <section id="dila-banner" style={{
      background: "url('images/banner.png') center/cover no-repeat",
      padding: '100px 20px',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      textAlign: 'right',
      minHeight: '400px',
      overflow: 'hidden' // Aby nám animace nevyhazovala scrollbar
    }}>
      <motion.div 
        // Animace celého boxu
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        style={{
          maxWidth: '600px', 
          marginRight: '15%', 
          background: 'rgba(0,0,0,0.3)', 
          padding: '40px', 
          borderRadius: '15px', 
          backdropFilter: 'blur(6px)',
          border: '1px solid rgba(255,255,255,0.1)'
        }}
      >
        <motion.h2 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 1 }}
          style={{
            fontSize: '2.2rem', 
            fontWeight: '700', 
            marginBottom: '25px', 
            textShadow: '2px 2px 8px rgba(0,0,0,0.5)',
            lineHeight: '1.3'
          }}
        >
          Z ručně opracovaného dřeva<br />vznikají nadčasové kusy
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.6 }}
        >
          <motion.a 
            href="#galerie" 
            className="btn-dubai"
            // Interaktivní efekty na tlačítku
            whileHover={{ 
              scale: 1.1,
              boxShadow: "0px 0px 15px rgb(255,255,255,0.5)" 
            }}
            whileTap={{ scale: 0.9 }}
            style={{ display: 'inline-block', textDecoration: 'none' }}
          >
            Zobrazit galerii
          </motion.a>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Banner;